Object.defineProperty(exports, "__esModule", { value: true });
exports.chunk = function (array, groupSize) {
    var groups = [];
    for (var i = 0; i < array.length; i += groupSize) {
        groups.push(array.slice(i, i + groupSize));
    }
    return groups;
};
exports.sum = function (array) {
    return array.reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
};
